export enum UpdateLicenseKeyStrategyEnum {
    HTTP = 'http',
    SOCKET = 'socket',
}
